// Keep public production sessions on the production API, even after a preview build.
const LIVE_API = "https://marketing-nadia.emergent.host";
const LIVE_HOSTS = new Set(["app.nadiacloud.com", "marketing-nadia.emergent.host"]);

export function backendUrlFor(hostname, configuredUrl) {
  if (LIVE_HOSTS.has(String(hostname || "").toLowerCase())) return LIVE_API;
  return String(configuredUrl || "").trim().replace(/\/+$/, "");
}
